// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2RgAK","empty":"ModalGraph_empty__369AP"};